module.exports = __webpack_public_path__ + "static/media/ecard_icon.4c78cb3f.png";